<template>
	<div class="container">
		<div v-if="isMove" style="text-align: center;font-size: 18px;width: 100%;background-color: orangered;color: #fff;z-index: 99;padding: 30px 0;position: fixed;left: 0;right: 0;">
			请在PC电脑上浏览该网站！
		</div>
		<div class="mianbao">
			<el-breadcrumb separator="/" separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/list' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item><a href="/">课程详情</a></el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="player-block fl-col" v-if="!isMove">
			<div class="player-top fl-al">
				<!-- <div class="what-media fl-al" style="margin-right: 36px;" v-if="mediaType == 'video'" @click="changeMedia">
					<img src="@/assets/icons/audio-icon.png" alt="" />
					<div style="">
						切换音频
					</div>
				</div> -->
				<div class="what-media fl-al" style="margin-right: 36px;" v-if="mediaType == 'audio'" @click="changeMedia">
					<img src="@/assets/icons/video-icon.png" alt="" />
					切换视频
				</div>
				<div class="fl-al" style="margin-right: 12px;">
					<el-switch
					  v-model="isAutoPlay"
					  active-color="#FF8B02"
					  inactive-color="#ddd"
					  @change="autoChange">
					</el-switch>
					<div class="" style="margin-left: 8px;">
						自动连播
					</div>
				</div>
			</div>
			<!-- <video src=""></video> -->
			<div class="video-content" id='video-content-box' style="position: relative;" >
				<!-- <video-player class=" video-player vjs-custom-skin" ref="videoPlayer" height='' id='myVideo'
					:options="playerOptions"></video-player> -->

				<!-- <video id="player-container-id" preload="auto" width="1200" height="602" playsinline webkit-playsinline
					x5-playsinline></video> -->
				<!-- <div class="watermark1" data-isWatermark="true"
				 style="background-color: pink;width: 50px;height: 50px;position: absolute;top: 80px;left: 99px; z-index: 9;">
					
				</div> -->
				<!-- <img :src="imagePath" alt="" class="watermark1" data-isWatermark="true" :style="{'left':waterLeft,'top':waterTop}"
				 style="position: absolute;top:40px;left: 50px; z-index: 9;height: 50px;opacity:0.9"/> -->
			</div>
			
			<div class="player-bottom" style="">

			</div>
		</div>
		<div class="name-detail">
			<div class="name-name">
				{{courseInfo.courseName}}
			</div>
			<div class="name-txt1">
				课程简介
			</div>
			<div class="name-introd">
				{{courseInfo.courseIntroduce}}
			</div>
			<div class="teacher-list fl-al">
				<el-popover placement="bottom" width="266" trigger="hover" v-for="(item,index) in courseInfo.lecturers"
					:title="item.lecturerName" :content="item.lecturerIntroduce">
					<div class="teacher-one" slot="reference">
						<img :src="item.lecImage" alt="" />
						{{item.lecturerName}}
					</div>
				</el-popover>

			</div>
		</div>
		<div class="course-chapter">
			<div class="chapter-tab fl-al">
				<div class="tab-one" v-for="(item,index) in typeAll" :class="[whichBig==index?'tab_act':'']"
					@click="chooseNav(index)">
					{{item}}
				</div>
			</div>
			<div class="chapter-cotent" v-if="whichBig == 0" v-html="courseInfo.courseContent">

			</div>
			<div class="chapter-cotent" v-if="whichBig != 0">
				<div class="chapter-list">
					<div class="chapter-one fl-al" v-for="(item,index) in chapterList[whichBig-1].smallArr"
						:class="[nowPlayLink==item.subsectionId?'chapter-choosed':'']" @click="PlayClass(item)">
						<div class="chapter-name">
							{{item.subsectionName}}
						</div>
						<div class="chapter-num fl-al">
							<div class="num-one">
								ㄍ {{MinuteTransform(item.videoMediaDuration)}}
							</div>
							<div class="num-one">
								⊙ 学习进度：{{item.rateLearn?item.rateLearn:0}}%
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<canvas id="watermark-canvas" ref="myCanvas" v-show="false"></canvas>
	</div>
</template>

<script>
	import {
		Toast,
		debounceNew
	} from '@/utils/index';
	import {
		courseDetailApi,
		courseChapterApi,
		courseStudyLengthApi,
		courseStudyPoistionApi
	} from '@/api/course/course';
	import {
		mapState
	} from 'vuex';
	var player = {
		width:0
	};
	export default {
		components: {
			// ScrollView,
		},
		data() {
			return {
				course_id: '',
				courseInfo: {},
				chapterList: [],
				typeAll: ['课程介绍'],
				whichBig: 0,
				currentRate: '1.0', //倍速
				mediaTime: '', //视频的当前播放时间
				nowPlayLink: '', //当前播放的课程id
				coursePoster: '', //课时封面
				oldPlayTime: 0, //之前的播放位置
				firstIndex: '', //一级章节当前索引
				secondIndex: '', //二级课时当前索引
				isAutoPlay:false,
				mediaType:'video',
				playerOptions: {
					playbackRates: [0.5, 1, 1.5, 2],
					aspectRatio: '12:6',
					//视频url设置,直播流为例
					sources: [{
						src: 'https://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8', //视频文件地址
						type: 'application/x-mpegURL' //视频类型，这里可以不写，如果写一定要写对，否则会无法播放
					}],
					// 其他设置项
					notSupportedMessage: "此视频暂无法播放，请稍后再试", //提示信息
					autoplay: false, //是否自动播放
					controls: true, //是否显示控制栏
					poster: '', //视频封面
				},
				fileId:'',
				appId:'1325005138',
				playerSignature:'',
				waterLeft:'5%',//水印left
				waterTop:'5%',//水印top
				showWatermark:'',//是否展示水印 播放的时候再展示
				watermarkInterval:'',
				playIng:false,
				imagePath:'',
				isQuan:false,//是否全屏
				isMove:false,//是否是移动端 是的话要关闭全屏
				isIosQQ:'',
				timerArr:[],
			}
		},
		mounted() {
			const userAgent = window.navigator.userAgent;
			if (/Mobile|Android|iPhone|iPod|iPad|Windows Phone/i.test(userAgent)){
				this.isMove = true
				if(userAgent.includes('QQBrowser') && /iPad|iPhone|iPod/.test(userAgent)){
					this.isIosQQ = true
				}
			}else{
				this.isMove = false
			}
			const video = document.createElement("video")
			video.width = '1200'
			video.height = '602'
			try{
				// 画出水印的样式
				const videoContainer = document.querySelector('.video-container');
				const canvas = document.getElementById('watermark-canvas');
				console.log(canvas);
				const ctx = canvas.getContext('2d');
					
				// // 设置Canvas尺寸
				// canvas.width = 200; // 设置水印图片的宽度
				// canvas.height = 50; // 设置水印图片的高度
					
				// 在Canvas上绘制文字水印
				 // 绘制第一行文本
				  ctx.font = '40px Arial';
				  ctx.fillStyle = '#666'; // 第一行文字颜色
				  ctx.fillText(`we can ${JSON.parse(localStorage.getItem('userInfo')).userId}`, 50, 70);
			
				  // 绘制第二行文本
				  ctx.fillStyle = '#fff'; // 第二行文字颜色
				  ctx.fillText(`we can ${JSON.parse(localStorage.getItem('userInfo')).userId}`, 50, 120);
				this.imagePath = canvas.toDataURL('image/png');
				// console.log(this.imagePath);
			}catch(e){
				
			}
			// 创建 MutationObserver 实例，监听节点变化
			var targetNode = document.getElementsByClassName('watermark1')
			this.observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					// 检查是否为添加或删除节点操作
					if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
						// 遍历所有新增节点
						mutation.removedNodes.forEach((node) => {
							// 检查新增节点是否为水印元素
							if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('watermark1')) {
								// 调用添加水印函数
								this.addWatermark();
								return;
							}
						});
					}else if(mutation.target.className === 'watermark1'){
						console.log(33);
						// 如果找到了具有该类名的元素，则将其从 DOM 中移除
						let h = document.querySelector('.watermark1');
						if(h)h.remove();
						// this.addWatermark();
						return;
					}
				});
			});
			// 配置 MutationObserver 监听的选项
			const observerConfig = { childList: true, subtree: true, attributes: true };
			// 启动 MutationObserver，开始监听 DOM 变化
			this.observer.observe(document.getElementById('video-content-box'), observerConfig);
		},
		async created() {
			this.course_id = this.$route.query.course
			this.nowPlayLink = this.$route.query.subsectionId
			this.nowTakeChapterId = this.$route.query.chapterId
			this.GetCourseDetail()
			await this.GetCourseChapter()
			this.GetVideoSrc(true)
			const proTimer = setInterval(() => {
				this.getProcess()
			}, 60000)
			this.timerArr.push(proTimer);
		},
		beforeDestroy() {
			if(player.width){
				player.dispose();
			}
			this.AddListenRecord()
			this.CloseTimer()
			this.watermarkInterval = ''
			this.observer.disconnect();
		},
		computed: {
			...mapState(['isLoggedIn']), // 在计算属性中映射用户的登录状态
		},
		watch: {
			isLoggedIn(newValue, oldValue) {
				console.log(newValue);
				// 监听用户的登录状态变化，并根据变化来更新页面渲染
				if (newValue) {
					// 用户已登录，执行相应的操作
				} else {
					// 用户已注销，执行相应的操作
					Toast('登录失效', 'error')
					setTimeout(() => {
						this.$router.go(-1);
					}, 500)
				}
			},
			// 发生变化 也就是链接发生变化
			fileId(newValue, oldVal){
				if (newValue != oldVal && oldVal) {
					// this.$nextTick(()=>{
					// 	this.$refs.wxPlayer.init()
					// 	this.$refs.wxPlayer.isLoading = true
					// 	this.$refs.wxPlayer.current = this.oldPlayTime
					// 	this.$refs.wxPlayer.hideControl(5000)
					// 	if(!this.$refs.wxPlayer.isStarting){
					// 		setTimeout(()=>{
					// 			this.$refs.wxPlayer.startCodePlay()
					// 		},300)
					// 	}
					// })
				}
			},
		},
		methods: {
			addWatermark(){
				const watermark = document.createElement('img');
				    watermark.classList.add('watermark1');
				    // watermark.textContent = 'Watermark';
					watermark.src = this.imagePath
				    // 样式和位置设置
				    watermark.style.position = 'absolute';
					watermark.style.height = '50px'
				    watermark.style.top = this.waterTop;
				    watermark.style.left = this.waterLeft;
				    watermark.style.zIndex = 9;
				    watermark.style.opacity = 0.9;
				    document.querySelector('.video-content').appendChild(watermark);
					this.watermarkInterval = setInterval(() => {
						this.calculateRandomPosition();
						watermark.style.top = this.waterTop;
						watermark.style.left = this.waterLeft;
					}, 18000); // 切换水印显示状态，每隔20秒执行一次20000
			},
			chooseNav(i) {
				if (this.whichBig != i) {
					if (i != 0) {
						this.nowTakeChapterId = this.chapterList[i - 1].chapterId
					}
					this.whichBig = i
				}
			},
			// 水印位置改变
			toggleWatermark() {
				return false
				this.watermarkInterval = setInterval(() => {
					if (this.playIng) {
						this.calculateRandomPosition();
						this.showWatermark = !this.showWatermark;
						this.showWatermark = true;
						setTimeout(() => {
							this.showWatermark = false;
						}, 18000); // 10秒后隐藏水印18000
					}
				}, 20000); // 切换水印显示状态，每隔20秒执行一次20000
			},
			//水印位置
			calculateRandomPosition() {
				// return false
				// 计算百分之二到百分之二十之间的随机比例
				const minRatio = 0.02;
				const maxRatio = 0.2;
				const randomRatioX = Math.random() * (maxRatio - minRatio) + minRatio;
				const randomRatioY = Math.random() * (maxRatio - minRatio) + minRatio;
			
				// 计算百分之80到百分之99之间的随机比例
				const minRatioOffset = 0.8;
				const maxRatioOffset = 0.99;
				const randomOffsetRatioX = Math.random() * (maxRatioOffset - minRatioOffset) + minRatioOffset;
				const randomOffsetRatioY = Math.random() * (maxRatioOffset - minRatioOffset) + minRatioOffset;
			
				// 计算位置坐标
				const minX = 100 * randomRatioX;
				const minY = 100 * randomRatioY;
				const maxX = 100 * randomOffsetRatioX;
				const maxY = 100 * randomOffsetRatioY;
			
				// 在范围内生成随机位置
				const randomX = Math.random() * (maxX - minX) + minX;
				const randomY = Math.random() * (maxY - minY) + minY;

				// this.waterTop = `${randomY}%`;
				// this.waterLeft = `${randomX}%`;
				
				this.$nextTick(()=>{
					this.waterTop = `${randomY}%`;
					this.waterLeft = `${randomX}%`;
				})
				// console.log('x：'+this.waterLeft+'y:'+this.waterTop);
				// console.log(this.isFullScreen);
				// console.log('Top', this.waterTop);
				// console.log('left', this.waterLeft);
			},
			changeMedia(){
				
			},
			autoChange(e){
			},
			CloseTimer() {
				this.timerArr.forEach(loopTimer => {
					clearInterval(loopTimer);
				});
				// 清空数组
				this.timerArr = [];
			},
			// 添加学习时长记录
			async AddTimeAdd(type){
				let data = {
					type:type,
					subsectionId:this.nowPlayLink
				}
				await courseStudyLengthApi(data)
			},
			async AddListenRecord() {
				let data = {
					subsectionId: this.nowPlayLink,
					moment: this.mediaTime,
					type: 1// 1-视频 2-音频
				}
				await courseStudyPoistionApi(data)
			},
			// 初始化播放器
			initPlayer(){
				const video = document.createElement("video")
				video.width = '1200'
				video.height = '602'
				video.setAttribute("id", "player-container-id");
				video.setAttribute('playsinline',true);
				video.setAttribute('webkit-playsinline',true)//  video的属性
				video.setAttribute('disablePictureInPicture', 'true'); //   禁用画中画
				video.setAttribute('controlsList', 'nodownload nopictureinpicture'); // 禁用下载和画中画
				document.getElementById("video-content-box").appendChild(video);//为这个盒子中添加一个video元素
				if(player.width){
					player.dispose();
				}
				let that = this
				this.$nextTick(()=>{
					player = TCPlayer("player-container-id", { // player-container-id 为播放器容器ID，必须与html中一致
						fileID: this.fileId, // 请传入需要播放的视频fileID 必须
						appID: this.appId, // 请传入点播账号的子应用appID 必须
						psign: this.playerSignature, // 请传入播放器签名psign 必须
						autoplay: !this.isMove ,// 是否自动播放
						poster:this.coursePoster,//是否显示封面
						playbackRates: [0.5, 1, 1.25, 1.5, 1.75, 2],
						controlBar :{
							fullscreenToggle:!this.isMove
						},
						plugins:{
							DynamicWatermark:{//动态水印
								type:this.imagePath ? 'image' : 'text',
								// content:`we can ${JSON.parse(localStorage.getItem('userInfo')).userId}`,
								content:this.imagePath || `we can ${JSON.parse(localStorage.getItem('userInfo')).userId}`,
								color:'#FF8B02',
								opacity:1,
								width: '100px',
								height:'50px'
								// left:this.waterLeft,
								// top:this.waterTop
							}
						},
						// 其他参数请在开发文档中查看
					})
					player.on('loadedmetadata', () => {
					  player.currentTime(this.chapterList[this.firstIndex].smallArr[this.secondIndex].moment);
					});
					player.on('play', function(error) {
					   // 做一些处理
					   // console.log('第一次播放');
					   console.log('播放');
					   that.watermarkInterval = setInterval(() => {
					   	that.calculateRandomPosition();
					   }, 18000); // 切换水印显示状态，每隔20秒执行一次20000
					   that.AddListenRecord()
					   const loopTimer = setInterval(() => {
					   	that.AddListenRecord()
					   }, 30000)
					   // that.AddTimeAdd(1)
					   // const longTimer = setInterval(() => {
					   // 	that.AddTimeAdd(0)
					   // }, 30000)
					   
					   // that.timerArr.push(longTimer);
					   that.timerArr.push(loopTimer);
					});
					player.on('playing', function(error) {
					   // 做一些处理
					   // console.log('开始播放');
					   that.playIng = true
					});
					player.on('timeupdate', () => {
					  const currentTime = player.currentTime();     // 当前播放时间（秒）
					  that.mediaTime = currentTime;
					});
					player.on('pause', function(error) {
					   // 做一些处理
					   console.log('视频暂停');
					   that.playIng = false
					   that.AddListenRecord()
					   that.CloseTimer()
					});
					// 可选：在页面销毁前再一次上报
					    this.$once('hook:beforeDestroy', () => {
							this.CloseTimer()
					      console.log('页面销毁');
					      // 上报最终 watched / 1000
					    });
					player.on('ended', function(error) {
					   // 做一些处理
					   console.log('视频结束');
					   if(that.isAutoPlay){
						   that.onNextBtnclick()
					   }
					});
					const controlBar = document.querySelector('.vjs-control-bar');
					let that = this
					player.on('fullscreenchange', function(error) {
					   // 做一些处理
					   this.isQuan = player.isFullscreen()
					   if(player.isFullscreen()){
						               // 如果当前 bottom 值为 -48px，则设置为 0，否则设置为 -48px
						controlBar.style.bottom = 0;
						   // that.$nextTick(()=>{
							   
							  //  player.plugins = {
							  //  	DynamicWatermark: {
							  //  		type: this.imagePath ? 'image' : 'text',
							  //  		content: this.imagePath ||
							  //  			`we can ${JSON.parse(localStorage.getItem('userInfo')).userId}`,
							  //  		color: '#FF8B02',
							  //  		opacity: 1,
							  //  		width: '100px',
							  //  		height: '50px',
							  //  		// left:this.waterLeft,
							  //  		// top:this.waterTop
							  //  	}
							  //  };
						   // })
						   
					   }else{
						   controlBar.style.bottom = '-48px';
					   }
					});
				})
			},
			// 下一课
			onNextBtnclick() {
				let i = this.firstIndex || 0
				let j = this.secondIndex || 0
				// this.chapterList[i].smallArr[j].moment = this.mediaTime //将切换前的时间赋值
				console.log(i + '!!' + j);
				if (this.secondIndex == this.chapterList[this.firstIndex].smallArr.length - 1) { //是当前章节的最后一课时
					i += 1;
					j = 0
				} else {
					j += 1
				}
				this.nowTakeChapterId = this.chapterList[i].chapterId
				this.nowPlayLink = this.chapterList[i].smallArr[j].subsectionId
				// this.oldPlayTime = 0
				this.oldPlayTime = this.chapterList[i].smallArr[j].moment
				this.GetVideoSrc('')
			},
			// 是否播放 下面分类里的
			PlayClass(item) {
				if (this.nowPlayLink == item.subsectionId) return false;
				console.log(item);
				let i = this.firstIndex || 0
				let j = this.secondIndex || 0
				if (this.chapterList[i].smallArr[j]) {
					// this.chapterList[i].smallArr[j].moment = this.mediaTime
				} //将切换前的时间赋值
				this.nowPlayLink = item.subsectionId
				this.oldPlayTime = item.moment
				window.scrollTo({
					top: 0,
					behavior: 'smooth' // 平滑滚动
				})
				this.GetVideoSrc('')
			},
			// 秒转分秒格式
			MinuteTransform(data) {
				// ?️ 获取完整分钟数
				const minutes = Math.floor(data / 60);
				// ?️ 获得剩余的秒数
				const seconds = data % 60;

				function padTo2Digits(num) {
					return num.toString().padStart(2, '0');
				}
				// ✅ 格式化为 MM:SS
				const result = `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
				// console.log(result); // ?️ "09:25"
				return result
			},
			// 获取视频路径
			GetVideoSrc(first) {
				let dd = ''
				if (this.chapterList.length) {
					let i = this.chapterList.findIndex(item => {
						return item.chapterId == this.nowTakeChapterId
					})
					let j = this.chapterList[i].smallArr.findIndex(item => {
						return item.subsectionId == this.nowPlayLink
					})
					console.log(this.nowPlayLink);
					console.log(i + ',' + j);
					if (j != -1) {
						let videoFileId = this.chapterList[i].smallArr[j].videoFileId
						let videoPlayerSignature = this.chapterList[i].smallArr[j].videoPlayerSignature
						let audioFileId = this.chapterList[i].smallArr[j].audioFileId
						let audioPlayerSignature = this.chapterList[i].smallArr[j].audioPlayerSignature

						this.videoTotalDuration = this.chapterList[i].smallArr[j].videoMediaDuration
						this.audioMediaDuration = this.chapterList[i].smallArr[j].audioMediaDuration
						this.coursePoster = this.chapterList[i].smallArr[j].subsectionImageUrl || this.courseInfo
							.courseImage
						// console.log(player.width);
						// console.log(player);
						this.playerSignature = videoPlayerSignature
						this.fileId = videoFileId
						this.initPlayer()
						
						// this.playerOptions.poster = this.chapterList[i].smallArr[j].subsectionImageUrl || this.courseInfo
						// 	.courseImage
						console.log(videoFileId + '视频路径');
						this.firstIndex = i
						this.secondIndex = j
						// setTimeout(() => {
						//   var div = document.getElementById('myVideo')
						//   var div1 = div.firstChild
						//   var div3 = document.createElement("div");
						//   div3.id = 'userName';
						//   div3.setAttribute("class", "resize-drag");
						//   // 从父组件传过来的水印内容
						//   div3.innerText = this.userName
						//   div3.style.cssText = "position:absolute;top:100px;left:150px; color:#e6984d;font-size:40px;opacity:0.5;padding-top:10px";
						//   div1.appendChild(div3)
						// }, 1000);
						// 初始是视频还是音频
						// if (first) {
						// 	this.$refs.wxPlayer.mediaType =  (videoFileId || !audioFileId) ? 'video' : 'audio'
						// }else{
						// 	// 切换的时候 先默认媒体顺位   若是没有默认媒体的链接  则切换
						// 	if (this.$refs.wxPlayer.mediaType == 'video') {
						// 		this.$refs.wxPlayer.mediaType = (videoFileId || !audioFileId) ? 'video' : 'audio'

						// 	} else {
						// 		this.$refs.wxPlayer.mediaType = audioFileId ? 'audio' : 'video'
						// 		this.audioCurrentTime = Math.round(this.chapterList[i].smallArr[j].moment)
						// 		console.log(this.audioCurrentTime);
						// 	}
						// }
						// this.fileId = this.$refs.wxPlayer.mediaType == 'video'?videoFileId:audioFileId
						// this.playerSignature = this.$refs.wxPlayer.mediaType == 'video'?videoPlayerSignature:audioPlayerSignature
					} else {}
				}
				// if(this.isFirstInit){
				// 	this.$nextTick(()=>{
				// 		this.$refs.wxPlayer.init();
				// 	})
				// }
			},
			// 获取课程详情
			async GetCourseDetail() {
				let data = {
					courseId: this.course_id
				}
				await courseDetailApi(this.course_id, data).then(res => {
					console.log(res);
					if (res.code != 200) {
						Toast('网络错误~', 'error')
						setTimeout(() => {
							this.$router.go(-1);
						}, 800)
					} else {
						this.courseInfo = res.data
					}
				})
			},
			// 获取课程章节
			async GetCourseChapter(readObj) {
				let data = {
					courseId: this.course_id
				}
				await courseChapterApi(this.course_id, data).then(res => {
					console.log(res);
					if (res.code != 200) {
						Toast('网络错误~', 'error')
						setTimeout(() => {
							this.$router.go(-1);
						}, 800)
					} else {
						this.chapterList = res.data
						let typeArr = this.chapterList.map(item => {
							return item.chapterName
						})
						this.typeAll = ['课程介绍', ...typeArr]
						for (var i = 0; i < this.chapterList.length; i++) {
							this.chapterList[i].smallArr = this.chapterList[i].children ? this.chapterList[i]
								.children : []
							if (this.chapterList[i].smallArr) {
								this.chapterList[i].smallArr.forEach(item => {
									item.isTake = false
								})
							}
						}
						let reallyI = 0
						for (var i = 0; i < this.chapterList.length; i++) { //有些课程可能第一章children为空
							if (this.chapterList[i].smallArr.length > 0) {
								reallyI = i
								break
							}
						}
						if (!this.nowPlayLink) { //没有听课记录
						this.nowTakeChapterId = this.chapterList[reallyI].chapterId //章节id
						this.nowPlayLink = this.chapterList[reallyI].smallArr[0].subsectionId //课时id
						} else {
							// this.oldPlayTime = readObj.moment
							let i = this.chapterList.findIndex(item => {
								return item.chapterId == this.nowTakeChapterId
							})
							this.whichBig = i + 1
						}
					}
				})
			},
			// 更新进度
			async getProcess(){
				let data = {
					courseId: this.course_id
				}
				await courseChapterApi(this.course_id, data).then(res => {
					console.log(res);
					if (res.code != 200) {
						Toast('网络错误~', 'error')
						setTimeout(() => {
							this.$router.go(-1);
						}, 800)
					} else {
						const newData = res.data
						for (var i = 0; i < newData.length; i++) {
							for (var j = 0; j < newData[i].children.length; j++) {
								this.chapterList[i].smallArr[j].rateLearn = newData[i].children[j].rateLearn
							}
						}
					}
				})
			},
		},
	};
</script>

<style lang="scss" scoped>
	::v-deep .vjs-control-bar {
		opacity: 1;
		bottom: -48px;
		background: #1C202A;
	}
	::-webkit-scrollbar {
		height: 5px;
		overflow: hidden;
		cursor: pointer;
	}
	
	::-webkit-scrollbar-thumb {
		/* 滚动条滑块圆角 */
		border-radius: 8px;
		/* 滚动条滑块背景色 */
		background: rgba(255, 139, 2, 0.35);
		position: absolute;
		bottom: 0;
	}
	.container {
		width: 1320px;
		margin: 0 auto;
		height: fit-content;
		overflow: hidden;
		padding: 0 60px;
		box-sizing: border-box;
		margin-bottom: 30px;
	}

	.mianbao {
		height: 74px;
		display: flex;
		align-items: center;
	}
	.player-block {
		width: 1200px;
		height: 674px;
		// height: 638px;
		background: rgba(0, 0, 0, 0.75);
		border-radius: 0px 0px 0px 0px;

		.player-top {
			height: 36px;
			background: rgba(20, 30, 37, 0.73);
			justify-content: flex-end;
			font-family: ABeeZee, ABeeZee;
			font-weight: 400;
			font-size: 12px;
			color: #999999;
			.what-media{
				cursor: not-allowed;
				// div{
				// 	cursor: pointer;
				// }
				img{
					width: 26px;
					height: 26px;
					margin-right: 5px;
				}
			}
		}

		.player-bottom {
			height: 36px;
			background: #1C202A;
		}

		// .video-content{
		// 	width: 100%;
		// 	height: 602px;
		// }
		video {
			width: 100%;
			height: 602px;
			flex: 1;
		}
	}

	.name-detail {
		width: 1200px;
		min-height: 149px;
		background: #FFFFFF;
		border-radius: 20px 20px 20px 20px;
		padding: 10px 32px;
		box-sizing: border-box;
		margin-top: 21px;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		position: relative;

		.name-name {
			font-weight: 500;
			font-size: 24px;
			color: #333333;
		}

		.name-txt1 {
			margin: 15px 0;
		}

		.name-introd {
			font-size: 14px;
			color: #999999;
		}

		.teacher-list {
			position: absolute;
			top: 10px;
			right: 32px;

			.teacher-one:hover {
				cursor: pointer;
			}

			.teacher-one {
				margin-right: 24px;
				font-size: 12px;

				img {
					background: #D9D9D9;
					width: 32px;
					height: 32px;
					border-radius: 50%;
					object-fit: contain;
					margin-bottom: 8px;
				}
			}
		}
	}
	
	.course-chapter {
		width: 1200px;
		margin-top: 17px;
		padding-bottom: 40px;
		background-color: #fff;
		border-radius: 20px 20px 20px 20px;
		.chapter-tab:hover{
			overflow-x: auto;
		}
		.chapter-tab {
			height: 60px;
			border-bottom: 2px solid #eee;
			box-sizing: border-box;
			padding: 22px 32px 10px;
			overflow-x: hidden;
			overflow-y: hidden;
			.tab-one {
				margin-right: 38px;
				// line-height: 1;
				position: relative;
				flex-shrink: 0;
			}

			.tab-one:hover {
				cursor: pointer;
				color: #FF8B02;
			}

			.tab_act {
				color: #FF8B02;
			}

			.tab_act::after {
				content: '';
				width: 100%;
				height: 4px;
				background: #FF8B02;
				border-radius: 2px 2px 2px 2px;
				position: absolute;
				bottom: -12px;
				left: 0;
			}
		}

		.chapter-cotent {
			padding: 16px 20px;

			.chapter-list {
				.chapter-one:hover {
					cursor: pointer;
					background: #FFEFE3;
					color: #FF9900;
				}

				.chapter-one {
					width: 1158px;
					height: 57px;
					background: #F8F8F8;
					border-radius: 20px 20px 20px 20px;
					margin-bottom: 12px;
					color: #808080;
					padding: 0 16px;
					box-sizing: border-box;

					.chapter-name {
						font-size: 22px;
						width: 800px;
					}

					.chapter-num {
						margin-right: 20px;

						.num-one:first-child {
							margin-right: 68px;
						}
					}
				}

				.chapter-choosed {
					background: #FFEFE3;
					color: #FF9900;
				}
			}
		}
	}
</style>